import { useApiClient } from "@/hooks/useApiClient";
import useSWRMutation, { type SWRMutationResponse } from "swr/mutation";

/**
 * 地図プロットリクエストの更新APIリクエストボディ
 */
export interface UpdateMapPlotRequestPayload {
  name?: string;
  tags?: string[];
}

/**
 * 地図プロットリクエストを更新するカスタムフック
 * @param plotRequestId - プロットリクエストID (undefinedの場合はミューテーションを実行しない)
 */
export const useUpdateMapPlotRequest = (
  plotRequestId: number | undefined
): SWRMutationResponse<
  void,
  Error,
  string | null,
  UpdateMapPlotRequestPayload
> => {
  const { apiClient } = useApiClient();
  const url = plotRequestId ? `/map/plot-request/${plotRequestId}` : null;

  const fetcher = async (
    url: string,
    { arg }: { arg: UpdateMapPlotRequestPayload }
  ): Promise<void> => {
    await apiClient.patch(url, arg);
  };

  return useSWRMutation(url, fetcher, { revalidate: false });
};
